import React from "react";

const Image = ({ src, alt, fallbackSrc }) => {
    const handleImageError = (e) => {
        e.target.onerror = null;
        e.target.src = fallbackSrc;
    };

    const imageSrc = src ? src : fallbackSrc;

    return <img className="product__photo" src={imageSrc} alt={alt} onError={handleImageError}></img>
}

export default Image;